import { founder } from '../../data/content';
import type { ArticleBlock as Block } from '../../core/types/content';

/** Eén blok uit de artikeltekst: alinea, tussenkop, lijst of tip. */
export function ArticleBlock({
  block
}: {
  block: Block;
}) {
  switch (block.type) {
    case 'h':
      return <h2 className="mt-12 font-display text-[1.75rem] font-light leading-snug text-ink first:mt-0" data-id="element-7609" data-mp="16kserbscqq1g">{block.text}</h2>;
    case 'list':
      return <ul className="mt-5 space-y-2.5 border-l border-line pl-5" data-id="element-7610" data-mp="1z866mvh70vep">
          {block.items.map((item, i) => <li key={`${i}-${item}`} className="text-[17px] leading-relaxed text-ink" data-id="element-7611" data-mp="2386t93eg4cwu" data-mpi={i}>
              {item}
            </li>)}
        </ul>;
    case 'tip':
      return <aside className="mt-8 bg-shell px-6 py-5 text-[16px] leading-relaxed text-ink" aria-label={`Tip van ${founder.firstName}`} data-id="element-7612" data-mp="1uf3ij2v6qe5w">
          <span className="font-display italic text-clay" aria-hidden="true" data-id="element-7613" data-mp="2i3w7ughaxnrj">
            Tip van {founder.firstName} —{' '}
          </span>
          {block.text}
        </aside>;
    case 'p':
      return <p className="mt-5 text-[17px] leading-[1.75] text-ink/85 first:mt-0" data-id="element-7614" data-mp="2sx70r61a82dl">{block.text}</p>;
  }
}